var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("page-nav-bar", {
          attrs: {
            currentServiceName: "MoneyRoad",
            subNavTitle: "Settings",
            menuAccess: true,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "settingBetweenList" }),
          _vm._v(" "),
          _c("div", { staticClass: "list-block" }, [
            _c("ul", [
              _vm.serviceName === "Payments" || _vm.serviceName === ""
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "item-link item-content",
                        attrs: { href: "/settings/application/" },
                      },
                      [
                        _c("div", { staticClass: "item-inner" }, [
                          _c("div", { staticClass: "item-title" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("settings.applctn_sttngs")) +
                                "\n                "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _vm.serviceName === "Direct Debit"
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "item-link item-content",
                        attrs: { href: "/settings/directDebit/" },
                      },
                      [
                        _c("div", { staticClass: "item-inner" }, [
                          _c("div", { staticClass: "item-title" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("settings.applctn_sttngs")) +
                                "\n                "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _vm.serviceName === "Direct Payments"
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "item-link item-content",
                        attrs: { href: "/settings/directPayments/" },
                      },
                      [
                        _c("div", { staticClass: "item-inner" }, [
                          _c("div", { staticClass: "item-title" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("settings.applctn_sttngs")) +
                                "\n                "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "toolbarPageBottomBlank" }),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "item-link item-content",
          attrs: { href: "/settings/remind/" },
        },
        [
          _c("div", { staticClass: "item-inner" }, [
            _c("div", { staticClass: "item-title" }, [
              _vm._v("Remind Settings"),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }